import FilmmakerBiography from "./FilmmakerBiography";

export const DETAILS = {
  year: "Year",
  runtime: "Runtime (min)",
  language: "Language",
  country: "Country",
  premiere: "Premiere",
  rating: "Rating",
  genre: "Genre",
  subtitle_language: "Subtitle Language",
  content_warning: "Content Warning",
  sponsor: "Sponsor",
  awards: "Awards",
  note: "Note",
  social_media: "Social Media"
};

export const CREDITS = {
  director: "Director",
  screenwriter: "Screenwriter",
  producer: "Producer",
  executive_producer: "Executive Producer",
  co_producer: "Co-Producer",
  filmmaker: "Filmmaker",
  cast: "Cast",
  cinematographer: "Cinematographer",
  editor: "Editor",
  animator: "Animator",
  production_design: "Production Design",
  composer: "Composer",
  sound_design: "Sound Design",
  music: "Music"
};

const makeDataTable = (data, source, expanded_credits) => {
  return (
    <ul>
      {Object.keys(source)
        .map(k => {
          if (k === "social_media") {
            if (
              !data["facebook"] &&
              !data["twitter"] &&
              !data["instagram"] &&
              !data["reddit"] &&
              !data["bluesky"] &&
              !data["tiktok"]
            ) {
              return null;
            } else {
              return (
                <li key={k}>
                  <div className="text-gray-400 leading-5 mt-3 uppercase text-xs">
                    {source[k]}
                  </div>
                  {data["facebook"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["facebook"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="Facebook"
                        style={{
                          marginLeft: -3,
                          marginRight: 12,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentcolor"
                              d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                  {data["twitter"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["twitter"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="X"
                        style={{
                          marginLeft: -3,
                          marginRight: 15,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          {/*Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"
                            fill="currentColor"
                          >
                            <path d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z" />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                  {data["instagram"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["instagram"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram"
                        style={{
                          marginLeft: -3,
                          marginRight: 12,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 551.034 551.034"
                          >
                            <path
                              fill="currentColor"
                              class="logo"
                              id="XMLID_17_"
                              d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
                            />

                            <path
                              fill="currentColor"
                              id="XMLID_81_"
                              d="M275.517,133C196.933,133,133,196.933,133,275.516 s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6 c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083 C362.6,323.611,323.611,362.6,275.517,362.6z"
                            />

                            <circle
                              fill="currentColor"
                              id="XMLID_83_"
                              cx="418.306"
                              cy="134.072"
                              r="34.149"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                  {data["reddit"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["reddit"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram"
                        style={{
                          marginLeft: -3,
                          marginRight: 12,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"
                            fill="currentColor"
                          >
                            {/* Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
                            <path d="M437 202.6C411.8 202.6 390.7 185.1 385.1 161.6C354.5 165.9 330.9 192.3 330.9 224L330.9 224.2C378.3 226 421.5 239.3 455.8 260.5C468.4 250.8 484.2 245 501.3 245C542.6 245 576 278.4 576 319.7C576 349.5 558.6 375.2 533.3 387.2C530.9 474 436.3 543.8 320.1 543.8C203.9 543.8 109.5 474.1 107 387.4C81.6 375.5 64 349.7 64 319.7C64 278.4 97.4 245 138.7 245C155.9 245 171.7 250.8 184.4 260.6C218.4 239.5 261.2 226.2 308.1 224.2L308.1 223.9C308.1 179.6 341.8 143 384.9 138.4C389.8 114.2 411.2 96 437 96C466.4 96 490.3 119.9 490.3 149.3C490.3 178.7 466.4 202.6 437 202.6zM221.5 319.3C200.6 319.3 182.6 340.1 181.3 367.2C180 394.3 198.4 405.3 219.3 405.3C240.2 405.3 255.9 395.5 257.1 368.4C258.3 341.3 242.4 319.3 221.4 319.3L221.5 319.3zM459 367.1C457.8 340 439.8 319.2 418.8 319.2C397.8 319.2 381.9 341.2 383.1 368.3C384.3 395.4 400 405.2 420.9 405.2C441.8 405.2 460.2 394.2 458.9 367.1L459 367.1zM398.9 437.9C400.4 434.3 397.9 430.2 394 429.8C371 427.5 346.1 426.2 320.2 426.2C294.3 426.2 269.4 427.5 246.4 429.8C242.5 430.2 240 434.3 241.5 437.9C254.4 468.7 284.8 490.3 320.2 490.3C355.6 490.3 386 468.7 398.9 437.9z" />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                  {data["bluesky"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["bluesky"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram"
                        style={{
                          marginLeft: -3,
                          marginRight: 12,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          {/* Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
                          <svg
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"
                          >
                            <path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z" />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                  {data["tiktok"] ? (
                    <div
                      className="text-gray-300 no-translate"
                      style={{ float: "left" }}
                    >
                      <a
                        className="no-underline m-2 cursor-pointer"
                        href={data["tiktok"]}
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram"
                        style={{
                          marginLeft: -3,
                          marginRight: 12,
                          marginTop: -3
                        }}
                      >
                        <div
                          aria-hidden="true"
                          style={{
                            display: "inline-block",
                            width: "1em",
                            height: "1em"
                          }}
                        >
                          {/* Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
                          <svg
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"
                          >
                            <path d="M544.5 273.9C500.5 274 457.5 260.3 421.7 234.7L421.7 413.4C421.7 446.5 411.6 478.8 392.7 506C373.8 533.2 347.1 554 316.1 565.6C285.1 577.2 251.3 579.1 219.2 570.9C187.1 562.7 158.3 545 136.5 520.1C114.7 495.2 101.2 464.1 97.5 431.2C93.8 398.3 100.4 365.1 116.1 336C131.8 306.9 156.1 283.3 185.7 268.3C215.3 253.3 248.6 247.8 281.4 252.3L281.4 342.2C266.4 337.5 250.3 337.6 235.4 342.6C220.5 347.6 207.5 357.2 198.4 369.9C189.3 382.6 184.4 398 184.5 413.8C184.6 429.6 189.7 444.8 199 457.5C208.3 470.2 221.4 479.6 236.4 484.4C251.4 489.2 267.5 489.2 282.4 484.3C297.3 479.4 310.4 469.9 319.6 457.2C328.8 444.5 333.8 429.1 333.8 413.4L333.8 64L421.8 64C421.7 71.4 422.4 78.9 423.7 86.2C426.8 102.5 433.1 118.1 442.4 131.9C451.7 145.7 463.7 157.5 477.6 166.5C497.5 179.6 520.8 186.6 544.6 186.6L544.6 274z" />
                          </svg>
                        </div>
                      </a>
                    </div>
                  ) : null}
                </li>
              );
            }
          } else if (!data[k]) {
            return null;
          }
          return (
            <li key={k}>
              <div className="text-gray-400 leading-5 mt-3 uppercase text-xs">
                {k === "runtime" ? "Runtime" : source[k]}
              </div>
              <div className="text-gray-300 leading-5 no-translate">
                {data[k]}{" "}
                {k === "runtime" && !isNaN(data[k]) ? "minutes" : null}
              </div>
            </li>
          );
        })
        .filter(x => !!x)}
      {expanded_credits && expanded_credits.length ? (
        <div>
          {expanded_credits.map(fc => {
            return (
              <li key={fc.id}>
                <div className="text-gray-400 leading-5 mt-3 uppercase text-xs">
                  {fc.label}
                </div>
                <div className="text-gray-300 leading-5 no-translate">
                  {fc.value}
                </div>
              </li>
            );
          })}
        </div>
      ) : null}
    </ul>
  );
};

export default function FilmDetailTable({
  film,
  filmmakerInfo = null,
  isVod,
  displayAds = []
}) {
  return (
    <div>
      {film.description ? (
        <div
          className="tenant-injected-html mb-2 text-gray-300 mt-2"
          dangerouslySetInnerHTML={{ __html: film.description }}
        />
      ) : null}
      {filmmakerInfo !== null &&
        (filmmakerInfo.description ||
          (filmmakerInfo.src && filmmakerInfo.name)) && (
          <FilmmakerBiography {...filmmakerInfo} />
        )}
      {film.details ? (
        <div className="flex flex-col-reverse sm:flex-row -mx-4 w-full">
          <div
            className={`flex flex-row w-full ${isVod ? "sm:w-2/3" : "sm:w-1/2"}`}
          >
            <div className={"w-1/2 px-4"}>
              {makeDataTable(film.details, DETAILS)}
            </div>
            <div className={"w-1/2 px-4"}>
              {makeDataTable(film.credits, CREDITS, film.expanded_credits)}
            </div>
          </div>

          {isVod ? (
            <div className="flex flex-col w-full sm:w-1/3">
              <div
                className={`px-4 block shadow rounded-lg border-2 mt-6 py-5 sm:p-6 border-gray-600 bg-gray-700 ${isVod ? "mt-2" : "mt-6"}`}
                style={{ maxHeight: isVod ? 250 : 150, overflowY: "auto" }}
              >
                <div className="text-gray-200 font-semibold no-translate">
                  {film.name}
                </div>
                <div className={"text-gray-300 text-sm no-translate"}>
                  {film.short_description}
                </div>
                {film.captions_available && (
                  <div className="text-gray-400 mt-2 text-sm flex flex-row items-center">
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6 mr-1"
                      style={{ marginLeft: -2 }}
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" />
                    </svg>
                    <span>Closed captions available</span>
                  </div>
                )}
              </div>
              {displayAds.map(({ url, image }, index) => (
                <div
                  key={index}
                  className={
                    (!isVod && index === 0 ? "mt-12" : "mt-6") +
                    " rounded-lg overflow-hidden"
                  }
                >
                  {url ? (
                    <a href={url} target="_blank">
                      <img className="w-full" src={image} />
                    </a>
                  ) : (
                    <img className="w-full" src={image} />
                  )}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
